const RELEVANT_COUNTRIES = [
	'AT',
	'BE',
	'BG',
	'HR',
	'CY',
	'CZ',
	'DK',
	'EE',
	'FI',
	'FR',
	'DE',
	'GR',
	'HU',
	'IE',
	'IT',
	'LV',
	'LT',
	'LU',
	'MT',
	'NL',
	'PL',
	'PT',
	'RO',
	'SK',
	'SI',
	'ES',
	'SE',
	'AD',
	'FO',
	'GI',
	'IS',
	'IM',
	'LI',
	'MC',
	'NO',
	'CH',
	'GB',
	'SM',
	'US',
	'CA',
];

export default RELEVANT_COUNTRIES;
